/**
 * Some businesses have asked that the display value for 'flow' be changed.
 */
// NOTE: The following two functions are temporary until we can complete the following SIM
// https://issues.amazon.com/issues/GSC-Forecasting-1984
export function getFlowDisplayNamesByTenant(business: string, country: string, flow: string): string {
    const flowToDisplayFlowByTenantMap: {[key: string]: string} = {
        'ssd-US-OutboundNewSites': 'Outbound New Sites',
        'ssd-US-InboundGrocery': 'Inbound Grocery',
        'ssd-AE-OutboundRush': 'Outbound Rush',
        'ssd-SA-OutboundRush': 'Outbound Rush',
        'ssd-AE-CustomerOutbound': 'Customer Outbound',
        'ssd-SA-CustomerOutbound': 'Customer Outbound',
        'ssd-AE-TransIns': 'Trans Ins',
        'ssd-SA-TransIns': 'Trans Ins',
        'ssd-AE-TransOuts': 'Reversals Proactive',
        'ssd-SA-TransOuts': 'Reversals Proactive',
    };
    const key = [business, country, flow].join('-');

    if (flowToDisplayFlowByTenantMap[key]) {
        return flowToDisplayFlowByTenantMap[key];
    }
    return flow;
}

export function getFlowByBusinessAndFlowDisplayName(businessId: string, flow: string): string {
    const flowDisplayNameToFlowByBusinessIdMap: {[key: string]: string} = {};
    const businessAndFlow = businessId.concat(flow);

    if (flowDisplayNameToFlowByBusinessIdMap[businessAndFlow]) {
        return flowDisplayNameToFlowByBusinessIdMap[businessAndFlow];
    }
    return flow;
}

export function getCountryFlagIconUrl(country: string): string {
    return `https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/${country.toLowerCase()}.svg`;
}
